import React from 'react'
import { csx, Text } from '@vtex/admin-ui'
import { FormattedNumber } from 'react-intl'

type AssemblyItemsDiscountTextProps = {
  listPrice: number | null | undefined
  currencyCode: string
  isDisabled: boolean
}

export const AssemblyItemsDiscountText = ({
  listPrice,
  currencyCode,
  isDisabled,
}: AssemblyItemsDiscountTextProps) => {
  if (!listPrice) {
    return null
  }

  return (
    <Text
      variant="detail"
      tone="secondary"
      className={csx({
        display: 'block',
        textDecoration: 'line-through',
        color: isDisabled ? '#747474 !important' : '',
      })}
    >
      <FormattedNumber
        style="currency"
        currency={currencyCode}
        value={listPrice / 100}
      />
    </Text>
  )
}
